import { render, staticRenderFns } from "./FormDocumentEmail.vue?vue&type=template&id=564413a2&"
import script from "./FormDocumentEmail.vue?vue&type=script&lang=js&"
export * from "./FormDocumentEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports